import { EmailType } from "../../../../../constants";
import { useSteps } from "../../../../../hook";

export const useBCSteps = () => {
  return useSteps({
    approved: EmailType.BCRA,
    completed: EmailType.BCRF,
    rejected: EmailType.BCRR,
  });
};
